import React from 'react';
import { GetForm_vm_form_formItems as FormItemType } from '../__generated__/GetForm';
import { ContentFormItem } from './form-items/ContentFormItem';
import { FieldFormItem } from './form-items/FieldFormItem';
import { HeadingFormItem } from './form-items/HeadingFormItem';
import { MediaFormItem } from './form-items/MediaFormItem';
import { RepeatableGroupFormItem } from './form-items/RepeatableGroupFormItem';

interface FormItemProps {
  data: FormItemType;
}

export function FormItem({ data }: FormItemProps) {
  switch (data.__typename) {
    case 'VOLUNTEER_FormItemHeadingType':
      return <HeadingFormItem data={data} />;

    case 'VOLUNTEER_FormItemMediaType':
      return <MediaFormItem data={data} />;

    case 'VOLUNTEER_FormItemContentType':
      return <ContentFormItem data={data} />;

    case 'VOLUNTEER_FormItemFieldType':
      return <FieldFormItem data={data} />;

    case 'VOLUNTEER_FormItemRepeatableGroupType':
      return <RepeatableGroupFormItem data={data as any} />;

    default:
      return null;
  }
}
